import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class AdminService {
  static adminCreate = async (
    name,
    address,
    phone,
    nic,
    role,
    access_level,
    email,
    password
  ) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/admin/create",
        data: {
          name: name,
          address: address,
          phone: phone,
          nic: nic,
          role: role,
          access_level: access_level,
          email: email,
          password: password,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static adminForgotPassword = async (email) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/admin/password-reset",
        data: {email},
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static adminValidateOTP = async (email, otp) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/admin/password-reset-validate-code",
        data: {email, otp},
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static adminResetNewPassword = async (email, newPassword) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/admin/password-reset-set-password",
        data: {email, newPassword},
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static adminDetails = async (rowsPerPage, page) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/admin/search",
        data: {
          filter: [],
          limit: rowsPerPage,
          skip: page * 10,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let adminDetail = response.data.data.results;

      return adminDetail;
    } catch (err) {
      throw err;
    }
  };

  static adminDelete = async (adminID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/admin/" + adminID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static adminDetailsID = async (adminID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/admin/admin/" + adminID,
        data: {
          filter: [],
          limit: 10,
          skip: 0,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let termDetailID = response.data.data;

      return termDetailID;
    } catch (err) {
      throw err;
    }
  };

  static adminUpdate = async (adminID, address, phone, nic, name, role) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/admin/update/" + adminID,
        data: {
          address: address,
          phone: phone,
          nic: nic,
          name: name,
          role: role,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  // static adminPasswordUpdate = async (adminID, password, confpassword) => {
  //   try {
  //     let response = await axios({
  //       method: "put",
  //       baseURL: API_ORIGIN + "/admin/password/update/",
  //       data: {
  //         password: password,
  //         confpassword: confpassword,
  //       },
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });
  //     let responseData = response.data.data;

  //     return responseData;
  //   } catch (err) {
  //     throw err;
  //   }
  // };

  static adminPasswordUpdate = async (adminID, password, confpassword) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/admin/new/password/update/" +adminID,
        data: {
          password: password,
          confpassword: confpassword,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };
}
